import Role from '../../../enums/role';
import CompanyRole from '../../../enums/companyRole';
export const getDefaultAppointeeModel = () => ({
    fiscalIdentifier: '',
    name: '',
    address: '',
    phoneNumber: '',
    faxNumber: '',
    email: ''
});
export const getActiveCompanyRole = (companyRoles = []) => {
    if (companyRoles.includes(Role.Universal))
        return CompanyRole.Universal;
    if (companyRoles.includes(Role.Creator) && companyRoles.includes(Role.Approver))
        return CompanyRole.NonUniversal;
    return null;
};
